import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

import {
  type GetLearningPathsParams,
  type GetStudentLearningPathsParams,
  type LearningPathsListResponse,
  learningPathsListResponseSchema,
} from '../schemas/learningPathsList.schema';

// Manager listing (admin/coordinators): scope is resolved by the backend from the logged user's profile.
export const getLearningPaths = httpGetAdapter<LearningPathsListResponse, GetLearningPathsParams>({
  url: '/v3/trilha-aprendizagem',
  schema: learningPathsListResponseSchema,
  unwrap: false,
  mapParams: (params) => ({ ...params }),
});

// Student listing: the student is resolved by the backend from the session.
export const getStudentLearningPaths = httpGetAdapter<LearningPathsListResponse, GetStudentLearningPathsParams>({
  url: '/v3/trilha-aprendizagem/aluno',
  schema: learningPathsListResponseSchema,
  unwrap: false,
  mapParams: (params) => ({ ...params }),
});
